module.exports = __webpack_public_path__ + "img/step4-mobile-en.1442bb9b.webp";